import { render } from "./CargaTarifaPres.vue?vue&type=template&id=35b35de4&scoped=true"
import script from "./CargaTarifaPres.vue?vue&type=script&lang=js"
export * from "./CargaTarifaPres.vue?vue&type=script&lang=js"

import "./CargaTarifaPres.vue?vue&type=style&index=0&id=35b35de4&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b35de4"]])

export default __exports__